export default "__VITE_ASSET__7D3tk$Xn__"